import { Object } from "core-js";

export default Object.freeze({
    Tracked: 'Tracked',
    Untracked: 'Untracked'
});